<router-outlet></router-outlet>

<!-- Global Overlay Components -->
<p-toast position="top-right" [life]="3000"></p-toast>
<p-confirmDialog 
    styleClass="rounded-xl overflow-hidden shadow-2xl"
    [style]="{width: '450px'}" 
    acceptButtonStyleClass="p-button-danger"
    rejectButtonStyleClass="p-button-text p-button-secondary">
</p-confirmDialog>
